// src/components/Header.jsx
import React from "react";
import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import ExportActions from "./ExportActions";

export default function Header({ month, year, exportRows, totals }) {
  const small = useMediaQuery("(max-width:900px)");
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const metaColor = isDark ? "#7ee2a8" : "#007a52";

  return (
    <Stack
      direction={small ? "column" : "row"}
      justifyContent="space-between"
      alignItems={small ? "flex-start" : "center"}
      spacing={small ? 2 : 0}
      sx={{ mb: 2 }}
    >
      {/* Left: title + meta */}
      <Stack spacing={0.5}>
        <Typography
          variant={small ? "h5" : "h4"}
          sx={{ fontWeight: 800, color: isDark ? "#7ee2a8" : "#56C662", letterSpacing: 0.2 }}
        >
          Salary Sheet
        </Typography>
        <Stack
          direction={small ? "column" : "row"}
          gap={small ? 0.5 : 2}
          sx={{ opacity: 0.9 }}
        >
          <Typography variant="body2" sx={{ color: metaColor }}>
            Payroll Month:{" "}
            <b>
              {new Date(2000, month, 1).toLocaleString("en-US", {
                month: "long",
              })}{" "}
              {year}
            </b>
          </Typography>
          <Typography variant="body2" sx={{ color: metaColor }}>
            Generated on: <b>{new Date().toLocaleDateString("en-GB")}</b>
          </Typography>
        </Stack>
      </Stack>

      {/* Right: export buttons (isolated) */}
      <ExportActions
        month={month}
        year={year}
        rows={exportRows}
        totals={totals}
      />
    </Stack>
  );
}
